import type {BioIconProps} from './common-types'

export function BrgIconBurgerMenu({fill = 'white', ...attributes}: BioIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        className="burger-line"
        d="M2.65625 17.75H21.3438"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="burger-line"
        d="M2.65625 12H21.3438"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="burger-line"
        d="M2.65625 6.25H21.3438"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
